import React, { FC } from 'react'
import { Avatar, Comment, Divider, List, Modal, ModalProps, Tag, Typography } from 'antd'
import { IComment } from '../../../types/results'

interface Props extends ModalProps {
  title?: string
  notes?: string
  comments?: IComment[]
  summary?: string
  accesses?: { name: string }[]
}

const ResultModal: FC<Props> = ({ title, summary, accesses, ...props }) => {
  return (
    <Modal title={title} width={800} footer={false} {...props}>
      <div className='mb-12'>
        {[...new Array(Math.round((accesses?.length || 5) / 5))].map((_, idx) => (
          <Tag key={idx} color='blue'>
            Role {idx + 1}
          </Tag>
        ))}
      </div>

      <Typography.Title level={5}>Summary</Typography.Title>
      <Typography.Text>{summary}</Typography.Text>

      <Divider />

      <Typography.Title level={5}>Comments</Typography.Title>
      <List
        itemLayout='horizontal'
        dataSource={accesses}
        renderItem={(access, idx) => (
          <Comment
            key={idx}
            author={access.name}
            avatar={<Avatar src='https://joeschmoe.io/api/v1/random' alt='Han Solo' />}
            content={
              <p>
                We supply a series of design principles, practical patterns and high quality design
                resources (Sketch and Axure), to help people create their product prototypes
                beautifully and efficiently.
              </p>
            }
            datetime={<span>{5 - idx} hours ago</span>}
          />
        )}
      />
    </Modal>
  )
}

export default ResultModal
